import { Injectable, Injector } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { UserDao } from '@app/dao/user/user.dao';
import { MaritalStatus } from '@app/forms/subscription/definition/interface/subscription';
import { take } from 'rxjs';
import { ProductsTypeEnum } from '../../definition/interface';
import FormGroupArray from '../../services/FormGroupArray';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  userId;
  constructor(
    protected formConstructor: PrFormConstructor,
    protected injector: Injector,
  ) {
    super(formConstructor);
    injector
      .get(UserDao)
      .getAuthentified()
      .pipe(take(1))
      .subscribe(user => {
        this.userId = user.id;
      });
  }

  isUnionRequired(productType: any, maritalSituation: any) {
    if (
      !maritalSituation ||
      !['MARRIED', 'CIVILPARTNER'].includes(maritalSituation)
    ) {
      return false;
    }

    const isGirardin = productType === ProductsTypeEnum.GIRARDIN;
    if (isGirardin) {
      return (
        maritalSituation &&
        ['MARRIED', 'CIVILPARTNER'].includes(maritalSituation)
      );
    }
    return false;
  }

  generateForm(entity: MaritalStatus, option?) {
    let options: AbstractControlOptions = {};
    const isCristalisOrganization = option?.isCristalisOrganization || false;
    const sessionConsultant = option?.sessionConsultant;
    const { productType } = option || {};
    return this.formBuilder.group(
      {
        ownerId: [entity?.ownerId],
        userFirstName: [entity?.userFirstName],
        userLastName: [entity?.userLastName],
        userMaritalSituation: [
          entity ? entity.userMaritalSituation : null,
          [
            !sessionConsultant || !isCristalisOrganization
              ? Validators.required
              : Validators.nullValidator,
            this.prFormService.RefreshEveryValidators(),
          ],
        ],
        marriageRegime: [
          entity ? entity.marriageRegime : null,
          [
            ['MARRIED', 'CIVILPARTNER'].includes(entity?.userMaritalSituation)
              ? Validators.required
              : Validators.nullValidator,
          ],
        ],
        unionDate: [
          entity ? entity.unionDate : null,
          this.isUnionRequired(productType, entity?.userMaritalSituation)
            ? Validators.required
            : Validators.nullValidator,
        ],
        unionPlace: [
          entity ? entity.unionPlace : null,
          this.isUnionRequired(productType, entity?.userMaritalSituation)
            ? Validators.required
            : Validators.nullValidator,
        ],
        unionContract: [
          entity && entity.unionContract ? entity.unionContract : false,
          this.isUnionRequired(productType, entity?.userMaritalSituation)
            ? Validators.required
            : Validators.nullValidator,
        ],
        userSpouseFirstName: [
          entity ? entity.userSpouseFirstName : null,
          this.isUnionRequired(productType, entity?.userMaritalSituation)
            ? Validators.required
            : Validators.nullValidator,
        ],
        userSpouseLastName: [
          entity ? entity.userSpouseLastName : null,
          this.isUnionRequired(productType, entity?.userMaritalSituation)
            ? Validators.required
            : Validators.nullValidator,
        ],
        userSpouseBirthName: [
          entity ? entity.userSpouseBirthName : null,
          this.isUnionRequired(productType, entity?.userMaritalSituation)
            ? Validators.required
            : Validators.nullValidator,
        ],
      },
      options,
    );
  }
  generate(entity: MaritalStatus[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      ownerId: this.userId,
    });
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  extract() {
    return this.form.value.owners;
  }
}
